import { createSelector } from "@ngrx/store";
import { AppStateInterface } from "../appState.interface";

export const featuresState = (state: AppStateInterface) =>
  state.featuresState;

export const allFeaturesSelector = createSelector(
    featuresState,
    (state) => state.features
);

export const allAvailableFeaturesSelector = createSelector(
    featuresState,
    (state) => state.availableFeatures
)

export const featureSuccessSelector = createSelector(
    featuresState,
    (state) => state.success
);

